import { useNavigate } from "react-router-dom";

/* Helper to get the index of the current selected Workspace  */
const WorkspaceSelector = () => {
    const navigate = useNavigate();

    const currentWorkspace = () => {
        const user = getUser();
        const indexStorage = localStorage.getItem("workspaceIndex");
        const index = indexStorage ? parseInt(indexStorage) : null;

        if (
            (!indexStorage || isNaN(index) || !user.workspace[index]) &&
            user.workspace.length > 0
        ) {
            setCurrentWorkspace(0);
            return 0;
        }

        return index ?? 0;
    };

    const setCurrentWorkspace = (index) => {
        localStorage.setItem("workspaceIndex", index)
        navigate("/app");
    }

    const getFullCurrentWorkspace = () => {
        const user = getUser()
        return user.workspace[currentWorkspace()]
    }

    const getUser = () => {
        return JSON.parse(localStorage.getItem("user"));
    }

    const checkForActiveUser = () => {
        const user = getUser();
        return user.active
    }

    const checkForExisting = () => {
        const user = getUser();
        return (user.workspace.length > 0 && checkForActiveUser())
    }

    return { currentWorkspace, setCurrentWorkspace, getFullCurrentWorkspace, checkForExisting, checkForActiveUser }
}

export default WorkspaceSelector